module.exports = __webpack_public_path__ + "static/bus-icons_desktop.8e0dd0a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Venue/bus-icons_desktop.svg
// module id = 628
// module chunks = 35783957827783